import rules from './rules'
import {
  pwdrepeat,
  accountProfile,
  mobilerepeat,
  emailrepeat,
  bindSetUser,
  bindSetMobile,
  bindSetEmail,
  // mergeUser,
  findpwd
} from '@/services/account'
import {
  merge
} from '@/services/merge'

export default {
  namespaced: true,
  companyDatas: {},
  state: {
    submitting: false,
    loadingDetails: false,
    userid: 0,
    accountDetail: {},
    mergeFormDatas: {},
    decorators: {
      mobile: ['mobile', { rules: rules.tel }],
      oldmobile: rules.tel,
      newmobile: ['newmobile', { rules: rules.tel }],
      checkcode: ['checkcode', { rules: rules.validCode }],
      newcheckcode: ['newcheckcode', { rules: rules.validCode }],
      email: ['email', { rules: rules.email }],
      oldemail: rules.email,
      newemail: ['newemail', { rules: rules.email }],
      password: ['password', { rules: rules.password }],
      newpwd: ['newpassword', { rules: rules.newPwd }],
      renewpwd: ['renewpassword', { rules: rules.repeatPwd }],
      username: ['username', { rules: rules.username }]
    }
  },
  mutations: {
    setSubmitting (state, value) {
      state.submitting = value
    },
    setCompanyDatas (state, value) {
      state.companyDatas = value
    },
    setMergeFormDatas (state, data) {
      state.mergeFormDatas = data
    },
    // 新增initialValue属性添加默认值
    attrDecoratorsInit (state, data) {
      for (let i in state.decorators[data.key]) {
        let item = state.decorators[data.key][i]
        if (Object.prototype.toString.call(item) === '[object Object]') {
          item.initialValue = data.value
        }
      }
    },
    setUserid (state, userid) {
      state.userid = userid
    },
    setAccountDetail (state, datas) {
      state.accountDetail = datas
    },
    setLoadingDetails (state, type) {
      state.loadingDetails = type
    }
  },
  actions: {
    // 修改密码
    async modifyPassword ({ commit }) {
      commit('setSubmitting', true)
      const chain = await pwdrepeat()
        .onSuccess(res => {
          console.log(res)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    async getUserInfo ({ commit }) {
      await accountProfile()
        .onSuccess(res => {
          commit('setCompanyDatas', res)
        })
        .config({ tip: false })
        .fetch()
    },

    async setInitMobile ({ commit, dispatch, state }) {
      const { companyDatas } = state
      if (JSON.stringify(companyDatas) === '{}') {
        dispatch('getUserInfo')
      }
      commit('attrDecoratorsInit', { 'key': 'mobile', 'value': companyDatas.mobile })
    },

    async setInitEmail ({ commit, dispatch, state }) {
      const { companyDatas } = state
      if (JSON.stringify(companyDatas) === '{}') {
        dispatch('getUserInfo')
      }
      commit('attrDecoratorsInit', { 'key': 'email', 'value': companyDatas.email })
    },

    async modifyMobile ({ commit }) {
      commit('setSubmitting', true)
      const chain = await mobilerepeat()
        .onSuccess(res => {
          console.log(res)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    async modifyEmail ({ commit }) {
      commit('setSubmitting', true)
      const chain = await emailrepeat()
        .onSuccess(res => {
          console.log(res)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    },
    // 设置登录账户
    async setUser ({ commit }) {
      commit('setSubmitting', true)
      const chain = await bindSetUser()
        .onSuccess(res => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    },

    // 绑定手机
    async bindMobile ({ commit }) {
      commit('setSubmitting', true)
      const chain = await bindSetMobile()
        .onSuccess(res => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    },

    // 绑定邮箱
    async bindEmail ({ commit }) {
      commit('setSubmitting', true)
      const chain = await bindSetEmail()
        .onSuccess(res => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    },

    // 合并帐号
    async mergeUser ({ commit }) {
      commit('setSubmitting', true)
      const chain = await merge()
        .onSuccess(res => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    },

    // 获取详情信息
    async fetchAccountInfoDatas ({ commit }) {
      commit('setLoadingDetails', true)
      const chain = await accountProfile()
        .onSuccess((raw) => {
          commit('setAccountDetail', raw)
        })
        .onNetComplete(() => {
          commit('setLoadingDetails', false)
        })
        .config({ tip: false })
      return chain
    },
    // 找回密码
    async findPwd ({ commit }) {
      commit('setSubmitting', true)
      const chain = await findpwd()
        .onSuccess(res => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    }

  }
}
